import { useLayoutEffect, useState } from "react";

// Measures an element's own rendered height live via ResizeObserver. Unlike measuring
// the gap between two sibling refs (see useMeasuredAvailableHeight), this reflects only
// the element's own box -- safe to use for chrome around a self-sizing board (a status
// bar, a control pad) without the circularity of measuring against something whose
// position is itself downstream of the board's size.
export default function useElementHeight(ref) {
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const measure = () => setHeight(el.getBoundingClientRect().height);
    measure();

    const observer = new ResizeObserver(measure);
    observer.observe(el);
    window.addEventListener("resize", measure);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [ref]);

  return height;
}
